import {Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {Currencies} from "../../../interfaces/currencies";
import {Dels, Orders, ReturnStatuses} from "../../../interfaces/orders-data";
import {formatUnixDateKyiv} from "../../../shared/kyiv-date";
import {takeUntil} from "rxjs/operators";
import {OrderedProducts} from "../../../interfaces/orders-history-data";
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../../services/base.service";
import {Subject} from "rxjs";
import {
  ModalFormationRequestReturnComponent
} from "../modal-formation-request-return/modal-formation-request-return.component";

@Component({
  selector: 'app-modal-select-goods-return',
  templateUrl: './modal-select-goods-return.component.html',
  styleUrls: ['./modal-select-goods-return.component.scss']
})
export class ModalSelectGoodsReturnComponent extends BaseService implements OnDestroy {
  @ViewChild(ModalFormationRequestReturnComponent) modalFormationRequestReturnComponentRef: ModalFormationRequestReturnComponent;

  @Input() dels: Dels[];
  @Input() currencies: Currencies[];
  @Input() returnStatuses: ReturnStatuses[];
  // бек віддає !empty(...) - JSON true/false, тож порівняння === 1 / === 0 ніколи не спрацьовували
  @Input() allow_to_return_goods_from_zakupolog: boolean;

  public isDestroyed: Subject<boolean> = new Subject<boolean>();
  public isOrderModalShow: boolean = false;
  public isReturnedAll: boolean = false;
  public errorCheckboxMessage: string = '';
  public changeButton: boolean = false;
  public isFormationRequestReturn: boolean = false;
  public isDarkBackground: boolean = false;
  public allowReturn: boolean;
  public currentOrder;
  public deliveryDates;
  public orderedProducts;
  public isArticlesShow: boolean = false;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  modalOrderShow(order: Orders) {
    this.currentOrder = order;
    // dels - лише доставки, доступні користувачу зараз; доставки замовлення там може вже не бути
    this.deliveryDates = (this.dels?.[this.currentOrder.delivery_id]?.delivery_dates || []).map(date => formatUnixDateKyiv(date));
    this.http.post(this.apiRoot + 'orders/show_order', {
      order_id: order.id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: OrderedProducts[]) => {
        this.orderedProducts = data;

        this.isReturnedAll = true;

        for (let op of this.orderedProducts) {
          op.name = op.name.replaceAll('&nbsp;', ' ');

          if (op.artikul === null) {
            op.artikul = '';
          } else if (typeof op.artikul === "number") {
            op.firstArticle = op.artikul;
          } else {
            op.firstArticle = op.artikul.split('|||')[0];
            op.resultLastArticleGood = op.artikul.split('|||');
            op.resultLastArticleGood.splice(0, 1);
            op.lastArticles = undefined;
            if (op.resultLastArticleGood.length) {
              op.lastArticles = op.resultLastArticleGood;
            } else {
              op.resultLastArticleGood = [];
            }
          }
          op.checkedReturned = false;
          op.countMax = op.count;
          if (!op.is_returned) {
            this.isReturnedAll = false;
          }
        }

        this.allowReturn = this.orderedProducts.some((ord: OrderedProducts) => ord.allow_self_return == true);

        this.currentOrder.summa = Math.ceil(this.currentOrder.summa);

        this.isOrderModalShow = true;
        this.isDarkBackground = true;
      });
  }

  articlesShow() {
    this.isArticlesShow = true;
  }

  checkValue() {
    this.changeButton = !!this.orderedProducts.find(el => el.checkedReturned === true);
    this.errorCheckboxMessage = '';
  }

  prepareDataToReturn() {
    // Рішення одне на весь список: раніше помилка ставилась за кожну невідмічену позицію вже після
    // відкриття заяви і висіла при відкритті повернення по наступному замовленню
    if (this.orderedProducts && this.orderedProducts.some(op => op.checkedReturned)) {
      this.modalFormationRequestReturnComponentRef.openModal();
      this.isFormationRequestReturn = true;
      this.isOrderModalShow = false;
      this.isDarkBackground = false;
      this.changeButton = false;
      this.errorCheckboxMessage = '';
    } else {
      this.errorCheckboxMessage = 'Виберіть будь ласка товар';
    }
  }

  closeModal() {
    this.isOrderModalShow = false;
    this.isFormationRequestReturn = false;
    this.isDarkBackground = false;
    this.errorCheckboxMessage = '';
    this.changeButton = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
